var app = angular.module("leonardo");

var PropertyStatisticsController = function($scope, $rootScope, $state, $q, PropertyService, FilterService,
                                            CategoryRestService, TemplateService, ReportService, ngDialog,
                                            AccountService, $timeout, ConfigThemeService) {

  $scope.property = $scope.$parent.property;
  $scope.expanded = false;
  $scope.recurrence = null;
  $scope.trailing = true;
  $scope.accountService = AccountService;

  $scope.pastDue = true;

  $scope.total_percent_done = $scope.property.status;

  $scope.taskGroupsTotal = [];
  if ($scope.property.task_summary){
    $scope.taskGroupsTotal.push($scope.property.task_summary.critical);
    $scope.taskGroupsTotal.push($scope.property.task_summary.normal);
    $scope.taskGroupsTotal.push($scope.property.task_summary.minor);
    $scope.totalGroup = $scope.property.task_summary.total;
    $scope.total_percent_done = $scope.property.task_summary.total.percent_done;
  }
  if ($scope.property.tasks_statistics) {
    if ($scope.property.tasks_statistics.total.critical) {
      $scope.pastDue = false;
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.total.critical);
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.total.normal);
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.total.minor);
      $scope.totalGroup = $scope.property.tasks_statistics.total;
      $scope.total_percent_done = $scope.property.tasks_statistics.total.total.percent_completed;
    }
    else {
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.critical);
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.normal);
      $scope.taskGroupsTotal.push($scope.property.tasks_statistics.minor);
      $scope.totalGroup = $scope.property.tasks_statistics.total;
      $scope.total_percent_done = $scope.property.tasks_statistics.total.total.percent_completed;
    }
  }


  $scope.getGroupColor = function (taskGroup) {
    var style = {
      background: ConfigThemeService.config.theme_config.errorColor
    };
    if (!isNull(taskGroup.total.total)) {
      if (taskGroup.total.total === 0) {
        style['background'] = ConfigThemeService.config.theme_config.successColor;
      }
      else {
        if (taskGroup.total.progress_status == PropertyService.PROGRESS_STATUS_OK) {
          style['background'] = ConfigThemeService.config.theme_config.successColor;
        }
        else if (taskGroup.total.progress_status == PropertyService.PROGRESS_STATUS_WARNING) {
          style['background'] = ConfigThemeService.config.theme_config.warningColor;
        }
      }
      return style;
    } else {
      if (taskGroup.total === 0) {
        style['background'] = ConfigThemeService.config.theme_config.successColor;
      }
      else {
        if (taskGroup.progress_status == PropertyService.PROGRESS_STATUS_OK) {
          style['background'] = ConfigThemeService.config.theme_config.successColor;
        }
        else if (taskGroup.progress_status == PropertyService.PROGRESS_STATUS_WARNING) {
          style['background'] = ConfigThemeService.config.theme_config.warningColor;
        }
      }
      return style;
    }
  };

  $scope.getOptionsTotal = function() {
    $scope.value = $scope.property.tasks_statistics.total.total.percent_completed + '%';
    if (($scope.totalGroup.total.completed == 0) && ($scope.totalGroup.total.total == 0)) {
      $scope.value = 'N/A';
    }
    var options = {
      color: ConfigThemeService.config.theme_config.errorColor
    };

    if (($scope.totalGroup.total.total === 0) || !$scope.pastDue) {
      options['color'] = ConfigThemeService.getColor('tertiaryColor', 0.2);
    }
    else {
      if ($scope.property.progress_status == PropertyService.PROGRESS_STATUS_OK) {
        options['color'] = ConfigThemeService.config.theme_config.successColor;
      }
      else if ($scope.property.progress_status == PropertyService.PROGRESS_STATUS_WARNING) {
        options['color'] = ConfigThemeService.config.theme_config.warningColor;
      }
    }
    return options;
  };

  $scope.expand = function() {
    if ($scope.expanded) {
      $scope.expanded = false;
      return;
    }
    $scope.reload().then(function() {
      $scope.expanded = true;
    });
  };

  $scope.setTrailing = function(trailing) {
    $scope.trailing = trailing;
    if (!$scope.trailing) {
      $scope.total_percent_done = $scope.totalGroup.percent_done;
    }
    else {
      $scope.total_percent_done = $scope.totalGroup.trailing_progress.total_percent_expected;
    }
  };

  $scope.uploadNovice = function() {
    var data = {
      'novice': !$scope.property.novice
    };
    $scope.property.setNovice(data).then(function (res) {
      $scope.property.novice = res.novice;
    });
  };

  $scope.reload = function() {
    var options = { recurrence: $scope.recurrence };
    var defer = $q.defer();
    var tasksPromises = [];
    PropertyService.get($scope.property.id).then(function (data) {
      tasksPromises.push(data.getTasksByPriority(options).then(function(results){
        var groups = results.plain();
        $scope.taskGroupsPriority = [];
        $scope.taskGroupsPriority.push(groups.critical);
        $scope.taskGroupsPriority.push(groups.normal);
        $scope.taskGroupsPriority.push(groups.minor);
        $scope.totalGroup = groups.total;
        if (!$scope.trailing) {
          $scope.total_percent_done = $scope.totalGroup.percent_done;
        }
        else {
          $scope.total_percent_done = $scope.totalGroup.trailing_progress.total_percent_expected;
        }
      }));
      tasksPromises.push(data.getTasksByCategory(options).then(function(results) {
        $scope.taskGroupsCategory = [];
        $scope.taskGroupsCategory_pre = results.plain();
        angular.forEach($scope.taskGroupsCategory_pre, function(value){
          if (angular.isObject(value)) {
            $scope.taskGroupsCategory.push(value);
          }
        });
      }));
      $q.all(tasksPromises).then(function(){
        defer.resolve();
      });
    });

    return defer.promise;
  };

  $scope.setRecurrence = function(recurrence) {
    $scope.recurrence = recurrence;
    $scope.reload();
  };

  $scope.goToIncompleteTasks = function(portfolio, property, taskGroup, group) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    $timeout(function() {
      FilterService.resetFilters();
      if (property) {
        promise = FilterService.setProperty(property);
      }
      else if (portfolio) {
        FilterService.setFilter('portfolio', portfolio.id, true);
        FilterService.removeFilter('property', true);
      }
      var priority = null;
      if (group === 'priority') {
        switch (taskGroup.label) {
          case 'Minor':
            priority = TemplateService.PRIORITY_MINOR;
            break;
          case 'Normal':
            priority = TemplateService.PRIORITY_NORMAL;
            break;
          case 'Critical':
            priority = TemplateService.PRIORITY_CRITICAL;
            break;
        }
      }
      if (group === 'category') {
        angular.forEach(CategoryRestService.getCollection(), function(value) {
          if (taskGroup.label === value.name) {
            FilterService.setFilter('category', value.id);
          }
        });
      }
      FilterService.setFilter('recurrence', $scope.recurrence);
      FilterService.setFilter('status', ReportService.STATUS_PENDING);
      $q.when(promise).then(function () {
        $state.go('property.tasks.incomplete', { priority: priority });
      });
    }, 0);
  };

  $scope.showPropertyStatistics = function (property) {
    ngDialog.open({
      template: 'views/templates/dialog/property/statistics.html',
      controller: 'PropertyStatisticsControllerDialog',
      className: 'ngdialog-theme-default ngdialog-task-report',
      data: {
        property: property
      }

    });
  };

};

app.controller('PropertyStatisticsController', ['$scope', '$rootScope', '$state', '$q', 'PropertyService',
  'FilterService', 'CategoryRestService', 'TemplateService', 'ReportService', 'ngDialog', 'AccountService',
  '$timeout', 'ConfigThemeService', PropertyStatisticsController]);
